import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Button, Input } from '@jaylabs/ui';
import Logo from '../components/Logo';
import './Auth.css';

function Register() {
  const bgImage = localStorage.getItem('dashboardBg') || '/backgrounds/Background-2-1024x682.jpg';
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    displayName: ''
  });
  const [fieldErrors, setFieldErrors] = useState({});
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();

  const validate = (name, value) => {
    switch (name) {
      case 'username':
        if (!value.trim()) return 'Username is required';
        if (value.length < 3) return 'At least 3 characters';
        if (!/^[a-zA-Z0-9_]+$/.test(value)) return 'Letters, numbers, and underscores only';
        return '';
      case 'email':
        if (!value.trim()) return 'Email is required';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'Enter a valid email';
        return '';
      case 'password':
        if (!value) return 'Password is required';
        if (value.length < 10) return 'At least 10 characters required';
        if (!/[A-Z]/.test(value)) return 'Add an uppercase letter';
        if (!/[0-9]/.test(value)) return 'Add a number';
        if (!/[^a-zA-Z0-9]/.test(value)) return 'Add a special character';
        return '';
      case 'displayName':
        if (!value.trim()) return 'Display name is required';
        return '';
      default:
        return '';
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (fieldErrors[name]) {
      setFieldErrors(prev => ({ ...prev, [name]: validate(name, value) }));
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setFieldErrors(prev => ({ ...prev, [name]: validate(name, value) }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const errors = {};
    Object.entries(formData).forEach(([name, value]) => {
      const err = validate(name, value);
      if (err) errors[name] = err;
    });
    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }

    setLoading(true);
    try {
      const result = await register(formData);
      if (result.success) {
        setTimeout(() => { window.location = '/'; }, 500);
      } else {
        setError(result.message || 'Registration failed');
        setLoading(false);
      }
    } catch (err) {
      setError(err.message || 'Registration failed');
      setLoading(false);
    }
  };

  return (
    <div
      className="dd-auth-page"
      style={{
        backgroundImage: `linear-gradient(180deg, rgba(255,255,255,0.65), rgba(255,255,255,0.65)), url(${bgImage})`
      }}
    >
      <div className="dd-auth-card">
        <div className="dd-auth-logo">
          <Logo size="lg" clickable={false} />
        </div>
        <h1 className="dd-auth-title">Create your account</h1>
        <p className="dd-auth-subtitle">Join Dope Dash and start leveling up</p>

        {error && <div className="dd-auth-error">{error}</div>}

        <form onSubmit={handleSubmit} noValidate>
          <div className="dd-auth-field">
            <label htmlFor="reg-display-name" className="dd-auth-label">Display Name</label>
            <Input
              id="reg-display-name"
              type="text"
              name="displayName"
              value={formData.displayName}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="How should we call you?"
              required
              size="lg"
            />
            {fieldErrors.displayName && <span className="dd-auth-field-error">{fieldErrors.displayName}</span>}
          </div>

          <div className="dd-auth-field">
            <label htmlFor="reg-username" className="dd-auth-label">Username</label>
            <Input
              id="reg-username"
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="yourhandle"
              required
              size="lg"
            />
            {fieldErrors.username && <span className="dd-auth-field-error">{fieldErrors.username}</span>}
          </div>

          <div className="dd-auth-field">
            <label htmlFor="reg-email" className="dd-auth-label">Email</label>
            <Input
              id="reg-email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="you@example.com"
              required
              size="lg"
            />
            {fieldErrors.email && <span className="dd-auth-field-error">{fieldErrors.email}</span>}
          </div>

          <div className="dd-auth-field">
            <label htmlFor="reg-password" className="dd-auth-label">Password</label>
            <Input
              id="reg-password"
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="10+ characters"
              required
              size="lg"
            />
            {fieldErrors.password
              ? <span className="dd-auth-field-error">{fieldErrors.password}</span>
              : <span className="dd-auth-hint">Uppercase, number & symbol required.</span>
            }
          </div>

          <Button
            type="submit"
            variant="primary"
            size="lg"
            loading={loading}
            style={{ width: '100%', marginTop: '0.5rem' }}
          >
            {loading ? 'Creating account…' : 'Create Account'}
          </Button>
        </form>

        <div className="dd-auth-links">
          <span>Already have an account? <a href="/login">Log in here</a></span>
        </div>
      </div>
    </div>
  );
}

export default Register;
